<template>
  <div>
    <Modal v-if="show" :show="show" @close="show = false">
      <div class="component">
        <h5 class="component-title">
          Save filter set
          <tooltip
            :content="
              'Please note, storing your data is offered as a service. <br />We are not responsible for data loss of any kind, like - but not limited to - server crash, tool’s functionality update or addition, phase-out of older products.'
            "
          />
        </h5>
        <p class="component-paragraph">
          Please give this filter set a description:
        </p>

        <label for="inputDescription">Description</label>
        <input
          type="text"
          class="form-control"
          id="inputDescription"
          name="inputDescription"
          v-model="inputDescription"
        />
        <div class="component-button">
          <input
            type="button"
            class="btn btn-outline-secondary"
            value="Cancel"
            @click="clickedCancel"
          />
          <input
            type="submit"
            class="btn btn-secondary"
            value="Save"
            :disabled="saveDisabled"
            @click="clickedSave"
          />
        </div>
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  name: "SaveFiltersetModal",
  data() {
    return {
      show: true,
      inputDescription: ""
    };
  },
  methods: {
    clickedSave() {
      if (this.saveDisabled) return;
      this.$emit("onSaveFilters", this.inputDescription);
      this.show = false;
    },
    clickedCancel() {
      this.show = false;
    }
  },
  computed: {
    saveDisabled() {
      return (
        this.inputDescription.length < 1 || this.inputDescription === "AUTOSAVE"
      ); //AUTOSAVE is a reserved name
    }
  }
};
</script>

<style lang="scss" scoped>
.component {
  display: flex;
  flex-flow: column wrap;
  justify-content: flex-start;
  .component-title {
    color: $blue;
    font-family: $font-family-sans-serif;
    font-weight: $btn-font-weight;
  }
  .component-paragraph {
    font-size: 16px;
  }
  .form-control {
    margin: 0 0 30px 0;
  }
  .component-button {
    margin-top: auto;
    display: flex;
    input {
      width: 100%;
      margin: 0 20px 0 0;
      &:last-of-type {
        margin: 0;
      }
    }
  }
}
</style>
